import * as e from "react";
import n from "../lib/IconBase.es.js";
import a from "../defs/ArrowBendUpLeft.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(n, { ref: t, ...r, weights: a }));
o.displayName = "ArrowBendUpLeftIcon";
const p = o;
export {
  p as ArrowBendUpLeft,
  o as ArrowBendUpLeftIcon
};
